import clsx from "clsx";

import styles from "./training-category-label.module.css";

const LABELS = {
  training: "Training",
  learning: "Learning",
  workshop: "Workshop",
} as const;

export type TrainingCategory = keyof typeof LABELS;

export interface TrainingCategoryLabelProps {
  variant: TrainingCategory;
  label?: string;
  className?: string;
}

export function TrainingCategoryLabel({ variant, label, className }: TrainingCategoryLabelProps) {
  const variantClass =
    variant === "training"
      ? styles.training
      : variant === "learning"
        ? styles.learning
        : styles.workshop;

  return (
    <span className={clsx(styles.root, variantClass, className)}>
      {label ?? LABELS[variant]}
    </span>
  );
}
